import { OptionSetDto } from '../typings/optionSets';
import api from './baseApi';

export const getOptionSet = async (setId: string, includeOptions: boolean): Promise<OptionSetDto> => {
    const response = await api.get('optionsets/private/' + setId, {
        params: {
            includeOptions: includeOptions
        }
    });

    return response.data;
};

export const getOptionSets = async (
    searchString: string,
    from: number,
    count: number,
    forDesignTemplate = false,
    store?: string
): Promise<OptionSetDto[]> => {
    const response = await api.get('optionsets', {
        params: {
            searchString: searchString,
            from: from,
            count: count,
            shop: store,
            forDesignTemplate: forDesignTemplate
        }
    });

    return response.data;
};

export const getOptionSetsCount = async (
    searchString: string,
    forDesignTemplate = false,
    store?: string
): Promise<{
    count: number;
}> => {
    const response = await api.get('optionsets/count', {
        params: {
            searchString: searchString,
            shop: store,
            forDesignTemplate: forDesignTemplate
        }
    });

    return response.data;
};

export const getOptionSetsWithCount = async (
    searchString: string,
    from: number,
    count: number,
    forDesignTemplate = false,
    store?: string
) => {
    const sets = getOptionSets(searchString, from, count, forDesignTemplate, store);
    const setsCpunt = getOptionSetsCount(searchString, forDesignTemplate, store);

    await Promise.all([sets, setsCpunt]);

    return {
        sets: await sets.then((response) => response),
        totalCount: await setsCpunt.then((response) => response.count)
    };
};

export const getProgress = async (progressIdentifier: string): Promise<number | null> => {
    const response = await api.get('optionsets/progress/' + progressIdentifier);
    return response.data.progress;
};

export const cloneOptionSet = async (optionSetId: string, skipTemplateRelationLogic = false): Promise<string> => {
    const response = await api.post('optionsets/clone/' + optionSetId, {
        skipTemplateRelationLogic: skipTemplateRelationLogic
    });
    return response.data?.id;
};
